export default __webpack_public_path__ + "static/media/instagram.9c4bb053.svg";